var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComunica(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 105.27,
    width: 47.97,
    height: 47.97,
    style: {
      fill: "#9C0510"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,153.24H142v-48h48v40A8,8,0,0,1,182,153.24Z",
    style: {
      fill: "#9C0510"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.67,82.72H60v-40a8,8,0,0,1,8-8H181.67a8,8,0,0,1,8,8Z",
    style: {
      fill: "#9C0510"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.8,
    y: 86.64,
    width: 47.97,
    height: 14.83,
    style: {
      fill: "#9C0510"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 86.64,
    width: 47.97,
    height: 14.83,
    style: {
      fill: "#9C0510"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.08,
    y: 105.55,
    width: 26.03,
    height: 47.97,
    style: {
      fill: "#9C0510"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.77,173.42h-32a8,8,0,0,1-8-8v-8.15h48v8.15A8,8,0,0,1,181.77,173.42Z",
    style: {
      fill: "#9C0510"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,173.42H68a8,8,0,0,1-8-8v-8.15h48v8.15A8,8,0,0,1,100,173.42Z",
    style: {
      fill: "#9C0510"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.17,211.68v2.07q0,5.49-5.18,5.49H65.21q-5.18,0-5.18-5.49V192.42q0-5.49,5.18-5.49H68q5.18,0,5.18,5.49v3.65H68.85v-3.33a1.69,1.69,0,0,0-1.94-1.89h-.85q-1.71,0-1.71,1.89v20.71q0,1.89,1.71,1.89h1.08q1.71,0,1.71-1.89v-1.76Z",
    style: {
      fill: "#9C0510"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.55,219.24q-5.22,0-5.22-5.49V192.46q0-5.54,5.18-5.54h4.14q5.18,0,5.18,5.54v21.29q0,5.49-5.22,5.49Zm1-3.92h2.2q1.71,0,1.71-1.89V192.73a1.69,1.69,0,0,0-1.93-1.89h-2a1.67,1.67,0,0,0-1.89,1.89v20.71A1.69,1.69,0,0,0,82.58,215.33Z",
    style: {
      fill: "#9C0510"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.42,205.92l4-19h4.77v32.32h-4.32l.45-21.15-3.24,15.3h-3.33l-3.24-15.3L99,219.24H94.64V186.93h4.77Z",
    style: {
      fill: "#9C0510"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.29,186.93v26.2q0,6.12-5.22,6.12h-3.65q-5.18,0-5.18-6.17V186.93h4.32v26.29q0,2.12,1.89,2.12h1.76q1.75,0,1.75-2.12V186.93Z",
    style: {
      fill: "#9C0510"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.3,202.55V186.93h4.32v32.32H143.3v-6.44l-4.64-14.72v21.15h-4.32V186.93h4.32Z",
    style: {
      fill: "#9C0510"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.67,219.24V186.93H156v32.32Z",
    style: {
      fill: "#9C0510"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,211.68v2.07q0,5.49-5.18,5.49H165q-5.18,0-5.18-5.49V192.42q0-5.49,5.18-5.49h2.79q5.18,0,5.18,5.49v3.65h-4.32v-3.33a1.69,1.69,0,0,0-1.94-1.89h-.85q-1.71,0-1.71,1.89v20.71q0,1.89,1.71,1.89h1.08q1.71,0,1.71-1.89v-1.76Z",
    style: {
      fill: "#9C0510"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.43,219.24h-4.32V192.46q0-5.54,5.18-5.54h3.24q5.18,0,5.18,5.54v26.78h-4.32V207.41h-5Zm5-15.75V192.73a1.67,1.67,0,0,0-1.89-1.89h-1.17a1.67,1.67,0,0,0-1.89,1.89v10.76Z",
    style: {
      fill: "#9C0510"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComunica);
export default __webpack_public_path__ + "static/media/comunica.273048f85711071b81289050f3fe05b5.svg";
export { ForwardRef as ReactComponent };